import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { portalAPI } from '../lib/api';
import { Lock, Mail, LogIn, ShieldCheck } from 'lucide-react';

export default function PortalLoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // If already logged in as portal user, redirect
    if (localStorage.getItem('mlx_portal_token')) {
      navigate('/portail');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await portalAPI.login(email, password);
      localStorage.setItem('mlx_portal_token', res.data.token);
      localStorage.setItem('mlx_portal_user', JSON.stringify(res.data.user));
      navigate('/portail');
    } catch (err) {
      setError(err.response?.data?.detail || 'Identifiants incorrects');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg-primary)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <img src="/branding/logo-white.png" alt="Adalia" className="h-16 mx-auto mb-4" />
          <h1 className="text-xl font-serif" style={{ color: 'var(--text-primary)' }}>Portail Client</h1>
          <p className="text-[12px] mt-1" style={{ color: 'var(--text-tertiary)' }}>Consultez vos dossiers et factures en toute sécurité</p>
        </div>

        <form onSubmit={handleSubmit} className="rounded-[12px] p-6 space-y-4" style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }} data-testid="portal-login-form">
          {error && <div className="px-3 py-2 rounded text-[12px] text-red-400" style={{ background: 'rgba(220,38,38,0.1)' }}>{error}</div>}
          <div>
            <label className="block text-[11px] uppercase tracking-[1px] mb-1.5" style={{ color: 'var(--text-tertiary)' }}>Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: 'var(--text-tertiary)' }} />
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="votre@email.com" className="w-full pl-10 pr-3 py-2.5 rounded-[8px] text-[13px] outline-none" style={{ background: 'var(--bg-tertiary)', border: '1px solid var(--border-color)', color: 'var(--text-primary)' }} data-testid="portal-email" />
            </div>
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[1px] mb-1.5" style={{ color: 'var(--text-tertiary)' }}>Mot de passe</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: 'var(--text-tertiary)' }} />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" className="w-full pl-10 pr-3 py-2.5 rounded-[8px] text-[13px] outline-none" style={{ background: 'var(--bg-tertiary)', border: '1px solid var(--border-color)', color: 'var(--text-primary)' }} data-testid="portal-password" />
            </div>
          </div>
          <button type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-[8px] text-[13px] font-semibold disabled:opacity-50" style={{ background: 'var(--text-primary)', color: 'var(--bg-primary)' }} data-testid="portal-submit">
            <LogIn className="w-4 h-4" /> {loading ? 'Connexion...' : 'Se connecter'}
          </button>
          <div className="flex items-center gap-2 pt-2 text-[11px]" style={{ color: 'var(--text-tertiary)' }}>
            <ShieldCheck className="w-3.5 h-3.5 text-green-500" />
            <span>Connexion sécurisée TLS — Vos données sont protégées</span>
          </div>
        </form>

        <div className="text-center mt-4">
          <a href="/" className="text-[11px]" style={{ color: 'var(--text-tertiary)' }}>← Retour au cabinet</a>
        </div>
      </div>
    </div>
  );
}
